<script>
  import { offlineMode } from '../stores.js'
</script>

{#if $offlineMode}
  <div class="pm-offline" role="status">
    Нет связи с API (paper / ops). Данные могут быть устаревшими. Проверьте сеть или сервис.
  </div>
{/if}
